import { Link } from '@tanstack/react-router';

/**
 * The way from one step's profile card to the whole workspace's (spec 215 US3):
 * "where else is this used?" comes up exactly where a profile is read.
 */
export function AiModelsLink({ workspaceId }: { workspaceId: string }) {
  return (
    <Link
      to="/workspaces/$workspaceId/ai-usage/models"
      params={{ workspaceId }}
      className="text-muted-foreground hover:text-foreground touch-target inline-flex items-center self-start text-xs underline-offset-4 hover:underline"
    >
      See the workspace’s AI models
    </Link>
  );
}
